export function Footer() {
  

  return (
    <footer className="bg-gray-100 dark:bg-slate-900 -mt-20 text-gray-900 dark:text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="border-t border-gray-300 dark:border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-600 dark:text-gray-400">
            © 2025 Hitesh Zade. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
